/* eslint-disable jsx-a11y/img-redundant-alt */
import Accordion from '@material-ui/core/Accordion';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { publicIconPath } from '@orientaction/utils';
import classNames from 'classnames';
import { FC, useMemo } from 'react';
import ReactHtmlParser from 'react-html-parser';
import style from './style';

interface IProps {
  accordionDetailsComponent?: any;
  accordionSummaryComponent?: any;
  summaryText: string;
  detailsText: string;
  accordionStyleOverride?: string;
  index: number;
  handleDelete: any;
  handleEdit: any;
  codeColor?: string;
  minInterval?: number;
  maxInterval?: number;
  diagram?: any;
  hasImage?: boolean;
  hasVideo?: boolean;
}

const OaAccordion: FC<IProps> = ({
  summaryText,
  detailsText,
  accordionSummaryComponent,
  accordionDetailsComponent,
  accordionStyleOverride,
  index,
  handleDelete,
  handleEdit,
  codeColor,
  minInterval,
  maxInterval,
  diagram,
  hasImage,
  hasVideo,
}) => {
  const classes = style();

  const oaAccordionSummary = useMemo(() => {
    return (
      accordionSummaryComponent || (
        <AccordionSummary
          className={classes.accordionSummary}
          expandIcon={<ExpandMoreIcon style={{ color: '#000A8C' }} />}>
          <div className={classes.flexContainer}>
            <div className={classes.circle}>
              <span className={classes.number}>N°{`${index + 1}`}</span>
            </div>
            <div className={classes.summaryText}>
              <Typography className={classes.summaryTextH6} variant="h6">
                {hasImage && (
                  <img 
                    src={`${publicIconPath}/oa_image_new.svg`} 
                    alt="" 
                    style={{ 
                      width: 15, 
                      height: 15, 
                      marginRight: 8,
                      verticalAlign: 'middle'
                    }} 
                  />
                )}
                {hasVideo && (
                  <img 
                    src={`${publicIconPath}/oa_icon_youtube.svg`} 
                    alt="" 
                    style={{ 
                      width: 15, 
                      height: 15, 
                      marginRight: 8,
                      verticalAlign: 'middle'
                    }} 
                  />
                )}
                <span className={classes.summaryTextSpan}>{ReactHtmlParser(summaryText)}</span>
              </Typography>
            </div>
            <div className={classes.buttonsContainer}>
              <IconButton className={classes.iconButton} onClick={handleDelete(index)}>
                <img src={`${publicIconPath}/oa_trash.svg`} alt="Custom Icon" />
              </IconButton>
              <IconButton className={classes.iconButton} onClick={handleEdit(index)}>
                <img src={`${publicIconPath}/oa_edit.svg`} alt="Edit Icon" />
              </IconButton>
            </div>
          </div>
        </AccordionSummary>
      )
    );
  }, [
    accordionSummaryComponent,
    classes.accordionSummary,
    classes.buttonsContainer,
    classes.circle,
    classes.flexContainer,
    classes.iconButton,
    classes.number,
    classes.summaryText,
    classes.summaryTextH6,
    handleDelete,
    handleEdit,
    hasVideo,
    index,
    summaryText,
    hasImage,
    classes.summaryTextSpan,
  ]);

  return (
    <div className={classNames(classes.root, accordionStyleOverride)}>
      <Accordion TransitionProps={{ unmountOnExit: true }}>
        {oaAccordionSummary}
        {diagram === 5 && (
          <div style={{ display: 'block', marginLeft: 5 }}>
            <Typography className={classes.variableNameLabel} component="span">
              Couleur personnalisée :{' '}
            </Typography>
            {codeColor && (
              <Typography className={classes.variableNameText} component="span">
                {codeColor}
              </Typography>
            )}
          </div>
        )}
        <AccordionDetails className={classes.accordionDetails}>
          {accordionDetailsComponent() ?? ''}
        </AccordionDetails>
      </Accordion>
    </div>
  );
};

export default OaAccordion;
